import {randomString} from './string.utils';

export function removeQueryParam(url: string, param: string): string {
    const urlObj = new URL(url);
    urlObj.searchParams.delete(param);
    return urlObj.toString();
}

export function generateRandomQueryVals(url: string, ignore: string[] = []): string {
    const urlObj = new URL(url);

    urlObj.searchParams.forEach((_, key) => {
        if (ignore.includes(key)) return;
        urlObj.searchParams.set(key, randomString(32));
    });

    return urlObj.toString();
}

export function normalizeRedirectUri(uri: string): string | null {
    const trimmed = uri.trim();
    if (!trimmed) return null;

    const withProtocol = /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed) ? trimmed : `https://${trimmed}`;

    try {
        const {protocol} = new URL(withProtocol);
        if (protocol !== 'http:' && protocol !== 'https:') return null;
        return withProtocol;
    } catch {
        return null;
    }
}
